export default __webpack_public_path__ + "static/media/ic-product.c5f26458.svg";